export enum TimeFormatType {
	Twelve = 1,
	TwentyFour = 2
}